import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { TRANSLATIONS_EN } from './en/translation';
import { TRANSLATIONS_PT } from './pt/translation';
import { TRANSLATIONS_ES } from './es/translation';
import { TRANSLATIONS_HE } from './he/translation';

const i18nInstance = i18n.createInstance();

i18nInstance.use(initReactI18next).init({
  resources: {
    en: {
      translation: TRANSLATIONS_EN,
      admin: TRANSLATIONS_EN.admin,
    },
    pt: {
      translation: TRANSLATIONS_PT,
      admin: TRANSLATIONS_PT.admin,
    },
    es: {
      translation: TRANSLATIONS_ES,
      admin: TRANSLATIONS_ES.admin,
    },
    he: {
      translation: TRANSLATIONS_HE,
      admin: TRANSLATIONS_HE.admin,
    },
  },
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18nInstance;
